/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacyBills } from 'app/entities/pharmacy-bill/pharmacy-bill.reducer';
import { getEntities as getPrescriptions } from 'app/entities/prescription/prescription.reducer';
import { getEntities as getPharmacies } from 'app/entities/pharmacy/pharmacy.reducer';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-history.reducer';

export const PharmacyHistoryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyBills = useAppSelector(state => state.pharmacyBill.entities);
  const prescriptions = useAppSelector(state => state.prescription.entities);
  const pharmacies = useAppSelector(state => state.pharmacy.entities);
  const pharmacyHistoryEntity = useAppSelector(state => state.pharmacyHistory.entity);
  const loading = useAppSelector(state => state.pharmacyHistory.loading);
  const updating = useAppSelector(state => state.pharmacyHistory.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyHistory.updateSuccess);

  const handleClose = () => {
    navigate(`/pharmacy-history${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacyBills({}));
    dispatch(getPrescriptions({}));
    dispatch(getPharmacies({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.tmDate !== undefined && typeof values.tmDate !== 'number') {
      values.tmDate = Number(values.tmDate);
    }
    if (values.noOfDrugs !== undefined && typeof values.noOfDrugs !== 'number') {
      values.noOfDrugs = Number(values.noOfDrugs);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...pharmacyHistoryEntity,
      ...values,
      bill: pharmacyBills.find(it => it.id.toString() === values.bill?.toString()),
      prescription: prescriptions.find(it => it.id.toString() === values.prescription?.toString()),
      pharmacy: pharmacies.find(it => it.id.toString() === values.pharmacy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...pharmacyHistoryEntity,
          bill: pharmacyHistoryEntity?.bill?.id,
          prescription: pharmacyHistoryEntity?.prescription?.id,
          pharmacy: pharmacyHistoryEntity?.pharmacy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyHistory.home.createOrEditLabel" data-cy="PharmacyHistoryCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyHistory.home.createOrEditLabel">Create or edit a PharmacyHistory</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-history-id"
                  label={translate('tinyMedicRestApp.pharmacyHistory.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHistory.tmDate')}
                id="pharmacy-history-tmDate"
                name="tmDate"
                data-cy="tmDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHistory.noOfDrugs')}
                id="pharmacy-history-noOfDrugs"
                name="noOfDrugs"
                data-cy="noOfDrugs"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHistory.excluded')}
                id="pharmacy-history-excluded"
                name="excluded"
                data-cy="excluded"
                type="text"
                validate={{
                  maxLength: { value: 150, message: translate('entity.validation.maxlength', { max: 150 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHistory.timestampentry')}
                id="pharmacy-history-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHistory.microSec')}
                id="pharmacy-history-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHistory.lastupdated')}
                id="pharmacy-history-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHistory.active')}
                id="pharmacy-history-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHistory.cursor')}
                id="pharmacy-history-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyHistory.billNumber')}
                id="pharmacy-history-billNumber"
                name="billNumber"
                data-cy="billNumber"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                id="pharmacy-history-bill"
                name="bill"
                data-cy="bill"
                label={translate('tinyMedicRestApp.pharmacyHistory.bill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyBills
                  ? pharmacyBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-history-prescription"
                name="prescription"
                data-cy="prescription"
                label={translate('tinyMedicRestApp.pharmacyHistory.prescription')}
                type="select"
                required
              >
                <option value="" key="0" />
                {prescriptions
                  ? prescriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-history-pharmacy"
                name="pharmacy"
                data-cy="pharmacy"
                label={translate('tinyMedicRestApp.pharmacyHistory.pharmacy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-history" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyHistoryUpdate;
